export default __webpack_public_path__ + "static/media/abuad_alumni_constitution.5ead5cc2.pdf";